/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/array-type, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types, @typescript-eslint/consistent-indexed-object-style, @typescript-eslint/no-redundant-type-constituents */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BaseCareTeamFieldsFragment = { __typename?: 'PatientCareTeamModel', id: string, resourceType?: string | null, patient_id: string, category?: Types.CareTeamCategory | null, note?: string | null, organization_ids?: Array<string> | null, participants?: Array<{ __typename?: 'ContactModel', id?: string | null, resourceType?: string | null, prefix?: string | null, first_name: string, last_name?: string | null, role_name: string, role_code: string, email?: string | null, phone?: string | null, address?: string | null, address2?: string | null, city?: string | null, region?: string | null, country?: string | null, postal_code?: string | null, org_type_code?: string | null, org_type_name?: string | null }> | null };

export type GetCareTeamQueryVariables = Types.Exact<{
  input: Types.GetCareTeamInput;
}>;


export type GetCareTeamQuery = { __typename?: 'Query', getCareTeam?: { __typename?: 'PatientCareTeamModel', id: string, resourceType?: string | null, patient_id: string, category?: Types.CareTeamCategory | null, note?: string | null, organization_ids?: Array<string> | null, participants?: Array<{ __typename?: 'ContactModel', id?: string | null, resourceType?: string | null, prefix?: string | null, first_name: string, last_name?: string | null, role_name: string, role_code: string, email?: string | null, phone?: string | null, address?: string | null, address2?: string | null, city?: string | null, region?: string | null, country?: string | null, postal_code?: string | null, org_type_code?: string | null, org_type_name?: string | null }> | null } | null };

export type UpsertCareTeamMutationVariables = Types.Exact<{
  input: Types.UpdateCareTeamInput;
}>;


export type UpsertCareTeamMutation = { __typename?: 'Mutation', updateCareTeam: { __typename?: 'PatientCareTeamModel', id: string, resourceType?: string | null, patient_id: string, category?: Types.CareTeamCategory | null, note?: string | null, organization_ids?: Array<string> | null, participants?: Array<{ __typename?: 'ContactModel', id?: string | null, resourceType?: string | null, prefix?: string | null, first_name: string, last_name?: string | null, role_name: string, role_code: string, email?: string | null, phone?: string | null, address?: string | null, address2?: string | null, city?: string | null, region?: string | null, country?: string | null, postal_code?: string | null, org_type_code?: string | null, org_type_name?: string | null }> | null } };

export type DeleteCareTeamMemberMutationVariables = Types.Exact<{
  input: Types.DeleteCareTeamMemberInput;
}>;


export type DeleteCareTeamMemberMutation = { __typename?: 'Mutation', deleteCareTeamMember: { __typename?: 'OperationOutcomeModel', resourceType?: string | null, issue: Array<{ __typename?: 'Issue', code: string, expression?: Array<string> | null }> } };

export const BaseCareTeamFieldsFragmentDoc = gql`
    fragment BaseCareTeamFields on PatientCareTeamModel {
  id
  resourceType
  patient_id
  category
  note
  organization_ids
  participants {
    id
    resourceType
    prefix
    first_name
    last_name
    role_name
    role_code
    email
    phone
    address
    address2
    city
    region
    country
    postal_code
    org_type_code
    org_type_name
  }
}
    `;
export const GetCareTeamDocument = gql`
    query getCareTeam($input: GetCareTeamInput!) {
  getCareTeam(input: $input) {
    ...BaseCareTeamFields
  }
}
    ${BaseCareTeamFieldsFragmentDoc}`;
export function useGetCareTeamQuery(baseOptions: Apollo.QueryHookOptions<GetCareTeamQuery, GetCareTeamQueryVariables> & ({ variables: GetCareTeamQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCareTeamQuery, GetCareTeamQueryVariables>(GetCareTeamDocument, options);
      }
export function useGetCareTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCareTeamQuery, GetCareTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCareTeamQuery, GetCareTeamQueryVariables>(GetCareTeamDocument, options);
        }
// @ts-ignore
export function useGetCareTeamSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCareTeamQuery, GetCareTeamQueryVariables>): Apollo.UseSuspenseQueryResult<GetCareTeamQuery, GetCareTeamQueryVariables>;
export function useGetCareTeamSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCareTeamQuery, GetCareTeamQueryVariables>): Apollo.UseSuspenseQueryResult<GetCareTeamQuery | undefined, GetCareTeamQueryVariables>;
export function useGetCareTeamSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCareTeamQuery, GetCareTeamQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCareTeamQuery, GetCareTeamQueryVariables>(GetCareTeamDocument, options);
        }
export type GetCareTeamQueryHookResult = ReturnType<typeof useGetCareTeamQuery>;
export type GetCareTeamLazyQueryHookResult = ReturnType<typeof useGetCareTeamLazyQuery>;
export type GetCareTeamSuspenseQueryHookResult = ReturnType<typeof useGetCareTeamSuspenseQuery>;
export type GetCareTeamQueryResult = Apollo.QueryResult<GetCareTeamQuery, GetCareTeamQueryVariables>;
export const UpsertCareTeamDocument = gql`
    mutation upsertCareTeam($input: UpdateCareTeamInput!) {
  updateCareTeam(input: $input) {
    ...BaseCareTeamFields
  }
}
    ${BaseCareTeamFieldsFragmentDoc}`;
export type UpsertCareTeamMutationFn = Apollo.MutationFunction<UpsertCareTeamMutation, UpsertCareTeamMutationVariables>;
export function useUpsertCareTeamMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCareTeamMutation, UpsertCareTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCareTeamMutation, UpsertCareTeamMutationVariables>(UpsertCareTeamDocument, options);
      }
export type UpsertCareTeamMutationHookResult = ReturnType<typeof useUpsertCareTeamMutation>;
export type UpsertCareTeamMutationResult = Apollo.MutationResult<UpsertCareTeamMutation>;
export type UpsertCareTeamMutationOptions = Apollo.BaseMutationOptions<UpsertCareTeamMutation, UpsertCareTeamMutationVariables>;
export const DeleteCareTeamMemberDocument = gql`
    mutation deleteCareTeamMember($input: DeleteCareTeamMemberInput!) {
  deleteCareTeamMember(input: $input) {
    resourceType
    issue {
      code
      expression
    }
  }
}
    `;
export type DeleteCareTeamMemberMutationFn = Apollo.MutationFunction<DeleteCareTeamMemberMutation, DeleteCareTeamMemberMutationVariables>;
export function useDeleteCareTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCareTeamMemberMutation, DeleteCareTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCareTeamMemberMutation, DeleteCareTeamMemberMutationVariables>(DeleteCareTeamMemberDocument, options);
      }
export type DeleteCareTeamMemberMutationHookResult = ReturnType<typeof useDeleteCareTeamMemberMutation>;
export type DeleteCareTeamMemberMutationResult = Apollo.MutationResult<DeleteCareTeamMemberMutation>;
export type DeleteCareTeamMemberMutationOptions = Apollo.BaseMutationOptions<DeleteCareTeamMemberMutation, DeleteCareTeamMemberMutationVariables>;
import { withMutationResponseHandler, withQueryResponseHandler } from '../hooks/useResponseHandler';
export const useGetCareTeam = withQueryResponseHandler(useGetCareTeamQuery);
export const useUpsertCareTeam = withMutationResponseHandler(useUpsertCareTeamMutation, "upsertCareTeam");
export const useDeleteCareTeamMember = withMutationResponseHandler(useDeleteCareTeamMemberMutation, "deleteCareTeamMember");